bovoApp.factory('Ticket', ['$http', function($http) {
    return {
        getAll: function(params) {
            return $http({
                method: 'GET',
                url: '/api/tickets',
                params: params
            });
        },

        get: function(id) {
            return $http({
                method: 'GET',
                url: '/api/tickets/' + id
            });
        },

        save: function(data) {
            return $http({
                method: 'POST',
                url: '/api/tickets',
                data: data,
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity
            });
        },

        update: function(id, data) {
            return $http({
                method: 'PUT',
                url: '/api/tickets/' + id,
                data: data
            });
        },

        delete: function(id) {
            return $http({
                method: 'DELETE',
                url: '/api/tickets/' + id
            });
        },

        getFormData: function() {
            return $http({
                method: 'GET',
                url: '/api/tickets/form-data'
            });
        },

        getStats: function() {
            return $http({
                method: 'GET',
                url: '/api/tickets/stats'
            });
        }
    };
}]);